import { createRequest } from "helpers/tools";

export const getSalesforceAuthUrl = async (data) => {
    return await createRequest({
        suffix: `salesforce`,
        handleError: true,
        method: "post",
        payload: data,
    });
};

export const salseForceConnectAut = async (data, id) => {
    return await createRequest({
        suffix: `salesforce/${id}/connect`,
        method: "post",
        payload: data,
        handleError: false,
    });
};

export const salesMappingUpdate = async (data, id) => {
    return await createRequest({
        suffix: `salesforce/${id}/update`,
        method: "put",
        payload: data,
        handleError: false,
    });
};

export const getsalesMapping = async (id) => {
    return await createRequest({
        suffix: `salesforce/${id}/fields`,
        method: "get",
        handleError: false,
    });
};

export const getSalesforceTest = async (id) => {
    return await createRequest({
        suffix: `salesforce/${id}/preview`,
        method: "get",
        handleError: false,
    });
};
